module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/banner/en-f5a25cb6881a95a9dfc5462fa8ef62fb.jpg";